import React, { FC } from 'react'

import { HowToSellCard } from '../HowToSellCard'
import * as Styled from './styled'

export const HowToSellContainer: FC = () => (
  <Styled.Card>
    <Styled.Header>
      <Styled.Heading2>How to level up?</Styled.Heading2>
      <Styled.ProgramDetailsLink to="/rewards">View full program details</Styled.ProgramDetailsLink>
    </Styled.Header>
    <Styled.ClassificationsContainer>
      <HowToSellCard
        title="Promote dispensary"
        description="Guide your patients' health and wellness with patient-direct shopping and shipping."
        link="/account/dispensary/dashboard"
        iconType="promote"
        text="Share dispensary link"
      />
      <HowToSellCard
        title="In-practice orders"
        description="Stock up on the #1 practitioner supplement brand recommended and trusted by functional medicine professionals.*"
        link="/products"
        iconType="educate"
        text="Order now"
      />
      <HowToSellCard
        title="Create eScript"
        description="Streamline your recommendations and boost patient compliance with a protocol."
        link="/escript/build"
        iconType="escript"
        text="Start an eScript"
      />
    </Styled.ClassificationsContainer>
  </Styled.Card>
)
